(function () {
  var BEARINGS = {
    B: 0.103,
    C: 0.103,
    D: 0.103,
    E: 0.103,
    F: 0.103,
    G: 0.103,
    H: 0.103,
    I: 0.103,
    K: 0.103,
    L: 0.103,
    M: 0.103,
    N: 0.103,
    O: 0.103,
    P: 0.103,
    Q: 0.103,
    R: 0.103,
    S: 0.04,
    T: 0.103,
    U: 0.103,
    Z: 0.04,
  };

  var SELECTOR = "h1, h2:not(.cart-notification__heading), h3, h4, .heading-xl, .heading-lg, .heading-md";

  function escapeHTML(str) {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function processHeading(el) {
    var style = window.getComputedStyle(el);
    if (style.textAlign === "center" || style.textAlign === "right") return;

    // Restore original text before re-processing (handles resize re-runs)
    if (el.dataset.opticalOriginal !== undefined) {
      el.textContent = el.dataset.opticalOriginal;
    }

    // Skip headings that contain child elements (links, em, etc.) — only handle plain text
    if (el.childElementCount > 0) return;

    var textNode = el.firstChild;
    if (!textNode || textNode.nodeType !== 3) return;

    var text = textNode.textContent;
    if (!text.trim()) return;

    el.dataset.opticalOriginal = text;

    // Walk each non-whitespace character and detect line starts by watching
    // for a downward jump in the character's rendered bounding rect top value
    var range = document.createRange();
    var lineStarts = [];
    var lastTop = null;

    for (var i = 0; i < text.length; i++) {
      if (!text[i].trim()) continue;
      range.setStart(textNode, i);
      range.setEnd(textNode, i + 1);
      var top = range.getBoundingClientRect().top;
      if (lastTop === null || top > lastTop + 2) {
        lineStarts.push({ pos: i, char: text[i].toUpperCase() });
        lastTop = top;
      }
    }

    if (
      !lineStarts.some(function (ls) {
        return BEARINGS[ls.char];
      })
    )
      return;

    // Rebuild the heading content, wrapping only line-starting characters
    // that need a bearing correction in an inline-block span
    var html = "";
    var cursor = 0;
    var wrappedWords = new Set();

    lineStarts.forEach(function (ls) {
      // Skip if this line start is inside a word we've already wrapped
      if (ls.pos < cursor) return;

      var bearing = BEARINGS[ls.char];
      if (!bearing) return;
      html += escapeHTML(text.slice(cursor, ls.pos));
      // Find the word starting at this position
      var wordMatch = text.slice(ls.pos).match(/^\w+/);
      var word = wordMatch ? wordMatch[0] : null;
      var isWordStart = ls.pos === 0 || /\s/.test(text[ls.pos - 1]);

      // Only wrap if at word start and this word hasn't been wrapped yet
      if (isWordStart && word && !wrappedWords.has(word)) {
        html +=
          '<span style="display:inline;margin-left:-' +
          bearing +
          'em;font-size:inherit;font-weight:inherit;letter-spacing:inherit;color:inherit;white-space:nowrap">' +
          escapeHTML(word) +
          "</span>";
        wrappedWords.add(word);
        cursor = ls.pos + word.length;
      } else {
        html += escapeHTML(text[ls.pos]);
        cursor = ls.pos + 1;
      }
    });
    html += escapeHTML(text.slice(cursor));

    el.innerHTML = html;
  }

  function runAll() {
    document.querySelectorAll(SELECTOR).forEach(processHeading);
  }

  if (document.readyState === "complete") {
    runAll();
  } else {
    window.addEventListener("load", runAll);
  }

  // Re-run when viewport width changes — line breaks shift, so corrections change
  var lastWidth = window.innerWidth;
  var resizeTimer;
  window.addEventListener("resize", function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(runAll, 150);
  });
})();
